// ============================================================================
// HEBREW TRANSLATIONS - JESUS IS NOT
// ============================================================================
// הבהרות תיאולוגיות על ישוע (הדגשת אהבה כוללת)

export const jesusIsNotHe = [
  {
    category: "כוללניות",
    text: "ישוע אינו גזען",
    reference: "יוחנן 4:9",
    context: "ישוע שוחח עם האישה השומרונית, חוצה מחסומי גזע ותרבות"
  },
  {
    category: "כוללניות",
    text: "ישוע אינו בלעדי",
    reference: "מתי 11:28",
    context: "הוא מזמין את כולם ולא דוחה שום לב כן"
  },
  {
    category: "אהבה",
    text: "ישוע לא אוהב בתנאים",
    reference: "רומים 5:8",
    context: "הוא מת בעדנו כשעדיין היינו חוטאים"
  },
  {
    category: "רחמים",
    text: "ישוע לא בא רק לשפוט",
    reference: "יוחנן 3:17",
    context: "המטרה העיקרית שלו היא להציל את העולם"
  },
  {
    category: "כוללניות",
    text: "ישוע אינו רק לעם אחד",
    reference: "יוחנן 10:16",
    context: "יש לו צאן אחרות מכל העמים"
  },
  {
    category: "נגישות",
    text: "ישוע אינו לאליטה",
    reference: "מרקוס 2:17",
    context: "הוא היה עם החולים, העניים והמודרים"
  },
  {
    category: "רחמים",
    text: "ישוע אינו בלתי סלחני",
    reference: "לוקס 23:34",
    context: "אפילו על הצלב, הוא סלח"
  },
  {
    category: "אהבה",
    text: "ישוע אינו אדיש",
    reference: "מתי 9:36",
    context: "כשראה את ההמונים, ריחם עליהם מאוד"
  },
  {
    category: "כוללניות",
    text: "ישוע אינו מפלה נשים",
    reference: "יוחנן 20:17",
    context: "כיבד נשים ובחר בהן כעדות ראשונות לתחייה"
  },
  {
    category: "רחמים",
    text: "ישוע אינו אלים",
    reference: "מתי 5:39",
    context: "לימד שלום ואי-אלימות"
  },
  {
    category: "נגישות",
    text: "ישוע אינו רחוק",
    reference: "מתי 28:20",
    context: "הבטיח להיות איתנו עד סוף העולם"
  },
  {
    category: "כוללניות",
    text: "ישוע אינו רק למעמד אחד",
    reference: "יעקב 2:1-9",
    context: "אין לו משוא פנים בין עשירים ועניים"
  },
  {
    category: "אהבה",
    text: "ישוע אינו רק כעס",
    reference: "יוחנן 13:1",
    context: "אהב אותנו עד הסוף"
  },
  {
    category: "רחמים",
    text: "ישוע אינו חוקני נוקשה",
    reference: "מרקוס 2:27",
    context: "אמר שהשבת נעשה למען האדם, לא האדם למען השבת"
  },
  {
    category: "כוללניות",
    text: "ישוע אינו שייך למסורת דתית אחת",
    reference: "יוחנן 4:21-24",
    context: "מלמד פולחן אוניברסלי ברוח ובאמת"
  },
  {
    category: "נגישות",
    text: "ישוע לא דורש טקסים דתיים מורכבים",
    reference: "מתי 18:3",
    context: "מבקש אמונה פשוטה כמו של ילד"
  },
  {
    category: "אהבה",
    text: "ישוע לא נוטר איבה",
    reference: "1 פטרוס 2:23",
    context: "כשהתגדף לא גידף בחזרה"
  },
  {
    category: "רחמים",
    text: "ישוע אינו מדכא",
    reference: "מתי 11:30",
    context: "עולו נעים ומשאו קל"
  },
  {
    category: "כוללניות",
    text: "ישוע לא מפלה לפי גיל",
    reference: "מרקוס 10:14",
    context: "מקבל בברכה ילדים ומכבד קשישים"
  },
  {
    category: "אהבה",
    text: "ישוע לא בא להרשיע חוטאים",
    reference: "יוחנן 8:11",
    context: "אמר לאישה הנואפת: 'גם אני לא מרשיע אותך'"
  }
];

export default jesusIsNotHe;
